import React, { useEffect, useState } from 'react';
import { Select, Input } from '../../../components/ui/Input';
import Btn from '../../../components/ui/Btn';
import { vendedoresApi } from '../../../api/admin';
import { condicoesPagamentoApi } from '../../../api/condicoesPagamento';
import CriarCondicaoPagamentoModal from '../CriarCondicaoPagamentoModal';

const FORMAS_PAGAMENTO = [
  { value: '', label: 'Selecione...' },
  { value: 'boleto', label: 'Boleto' },
  { value: 'pix', label: 'Pix' },
  { value: 'cartao', label: 'Cartão' },
  { value: 'transferencia', label: 'Transferência' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'dinheiro', label: 'Dinheiro' }
];

export default function ComercialTab({ form, onChange }) {
  const [vendedores, setVendedores] = useState([]);
  const [condicoes, setCondicoes] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);

  useEffect(() => { vendedoresApi.listar().then(setVendedores).catch(() => {}); }, []);

  const carregarCondicoes = () => {
    if (!form.forma_pagamento_principal) { setCondicoes([]); return; }
    condicoesPagamentoApi.listar({ forma_pagamento: form.forma_pagamento_principal }).then(setCondicoes).catch(() => {});
  };
  useEffect(carregarCondicoes, [form.forma_pagamento_principal]); // eslint-disable-line

  const opcoesVendedores = [{ value: '', label: '(nenhum)' }, ...vendedores.map(v => ({ value: v.id, label: v.nome }))];
  const opcoesCondicoes = [{ value: '', label: condicoes.length ? 'Selecione...' : '(nenhuma cadastrada ainda)' }, ...condicoes.map(c => ({ value: c.id, label: c.nome }))];

  const onCriada = (novoId) => {
    setModalAberto(false);
    carregarCondicoes();
    onChange('condicao_pagamento_id', novoId);
  };

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
      <Select label="Vendedor Principal" options={opcoesVendedores} value={form.vendedor_principal_id || ''} onChange={e => onChange('vendedor_principal_id', e.target.value || null)} />
      <Select label="Forma de Pagamento Principal" options={FORMAS_PAGAMENTO}
        value={form.forma_pagamento_principal || ''}
        onChange={e => { onChange('forma_pagamento_principal', e.target.value); onChange('condicao_pagamento_id', null); }} />
      <Input label="Limite de Crédito R$" type="number" step="0.01" min="0"
        value={form.limite_credito ?? 10000} onChange={e => onChange('limite_credito', e.target.value)} />

      {form.forma_pagamento_principal && (
        <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 10, alignItems: 'end' }}>
          <Select label="Condição de Pagamento" style={{ flex: 1 }} options={opcoesCondicoes}
            value={form.condicao_pagamento_id || ''} onChange={e => onChange('condicao_pagamento_id', e.target.value || null)} />
          <Btn variante="secondary" type="button" onClick={() => setModalAberto(true)}>+ Nova Condição</Btn>
        </div>
      )}

      {modalAberto && (
        <CriarCondicaoPagamentoModal
          formaInicial={form.forma_pagamento_principal}
          onFechar={() => setModalAberto(false)}
          onCriada={onCriada}
        />
      )}
    </div>
  );
}
